import { render, staticRenderFns } from "./centerLeft1.vue?vue&type=template&id=38eca6a0&scoped=true&"
import script from "./centerLeft1.vue?vue&type=script&lang=js&"
export * from "./centerLeft1.vue?vue&type=script&lang=js&"
import style0 from "./centerLeft1.vue?vue&type=style&index=0&id=38eca6a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eca6a0",
  null
  
)

export default component.exports